import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Aircall from './aircall-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Aircall {...validProps} />;
}
SvgComponent.iconName = 'aircall';

export const AircallIcon = svgIconWrapper(SvgComponent);
